export default {
    LOGIN: 'login',
    DIALOG: 'dialog',
    SETTINGS: 'settings',
    ABOUT: 'about',
    WORKBENCH: 'workbench',
    OAUTH: 'oauth',
};
